<template>
    <div class="row">
        <div v-if="record.unit!=='time'">
        <input id="record.skill" type="number" step="0.25" class="validate" v-model.lazy.number="record.value" :disabled="isReadOnly">
        <label for="record.skill" class="active">{{record.description}}</label>
        </div>
        <div v-if="record.unit=='time'">
          <div class="input-field col s6">
            <input id="record.skill + '-Minutes'" v-model.lazy.number="record.valueMinutes" type="number" step=1 class="validate" :disabled="isReadOnly">
            <label for="record.skill + '-Minutes" class="active">Minutes</label>
          </div>
          <div class="input-field col s6">
            <input id="record.skill + '-Seconds'" v-model.lazy.number="record.valueSeconds" type="number" step=1 class="validate" min=0 max=60 :disabled="isReadOnly">
            <label for="record.skill + '-Seconds'" class="active">Seconds</label>
          </div>
          <span class="helper-text" data-error="wrong">{{record.description}}</span>
        
        </div>
    </div>
</template>

<script>
export default {
  name: 'inputRecord',
  props: {
    record: Object,
    isReadOnly: Boolean
  }
}
</script>




// WEBPACK FOOTER //
// src/components/records/InputRecord.vue